export const firebaseConfig = {
  apiKey: 'AIzaSyB0xWhR54pphqyhc8Ac6q3KOSRWbhVVlB0',
  authDomain: 'distill-hq.firebaseapp.com',
  projectId: 'distill-hq',
  storageBucket: 'distill-hq.firebasestorage.app',
  messagingSenderId: '584370258242',
  appId: '1:584370258242:web:4142eb9cf78730d39508db',
  measurementId: 'G-9NEVVF3DCX',
};

export const firebaseVapidToken =
  'BJIgapXOBBlEqHhAt6Tn57oGCfoGmPZMT3G2359c-icEw8yYo7gnWyntF1JFfecH522MgqCr8HMTSYtf0URaQa8';
